<template>
	<div class="full box">
		<div class="full flex scan_container" v-if="!isscan">
			<van-icon size="200px" name="scan" @click="scan" />
			<div>点击扫描业务二维码</div>
		</div>

		<div class="full flex" v-if="isscan"
			style="flex-direction: column;align-items: center;justify-content: center;overflow: hidden;background-color: black;">
			<div id="reader"></div>
			<van-button type="primary" style="position: absolute;bottom: 50px;width: 50%;" size="small"
				@click="scanback">停止扫码</van-button>
		</div>

		<van-popup v-model="popupShow" position="bottom" :style="{ height: '80%' }" :safe-area-inset-bottom="true"
			@closed="closed" @open="open">
			<component :key="moduleKey" :is="formModule.component" :param="formModule.param" @submit="submit" />
		</van-popup>
	</div>
</template>
<style scoped>
	.box {
		box-sizing: border-box;
		padding: 4px 20px;
		overflow: auto;
	}

	#reader {
		position: absolute;
		left: 0;
		top: 0;
		width: 600px;

	}

	.scan_container {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	#scan-line {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 2px;
		background-color: red;
		animation: scan-animation 2s infinite;
	}

	@keyframes scan-animation {
		0% {
			top: 0;
		}

		100% {
			top: 100%;
		}
	}
</style>
<script>
	import {
		Html5Qrcode
	} from "html5-qrcode";
	export default {
		name: 'scanIndex',
		props: {

		},
		data() {
			return {
				popupShow: false,
				moduleKey: Math.random(),
				formModule: {
					component: null,
					param: null,
				},
				isscan: false,
				param: null,
				html5QrCode: null
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {
			scanmoduleMap() {
				return this.$store.state.scanmoduleMap
			},
		},

		methods: {
			scan() {

				//this.popupShow = true
				try {
					this.isscan = true
					this.$nextTick(() => {
						const html5QrCode = new Html5Qrcode("reader");
						const qrCodeSuccessCallback = (decodedText) => {
							if (decodedText) {
								this.param = decodedText
								this.popupShow = true
							}
						}
						const config = {
							fps: 10,
							qrbox: {
								width: 250,
								height: 250
							}
						};
						html5QrCode.start({
							facingMode: "environment"
						}, config, qrCodeSuccessCallback).catch(() => {
							this.scanback()
							this.$message.error('扫码失败')
						})

						this.html5QrCode = html5QrCode
					})
				} catch (error) {
					this.scanback()
					this.$message.error(error)
				}


			},
			scanback() {
				if (this.html5QrCode) {
					try {
						this.html5QrCode.stop().then(() => {
							this.isscan = false
							// QR Code scanning is stopped.
						})
					} catch (e) {
						this.isscan = false
					}

				} else {
					this.isscan = false
				}

			},
			open() {
				// this.param = JSON.stringify({
				// 	module: 'purchasevoucher',
				// 	action: 'uploadvoucher',
				// 	param: {
				// 		relationid: 10761
				// 	}
				// })
				let param = JSON.parse(this.param)
				console.log(param)
				import(`@/views/scan/index.vue`).then((res) => {
					this.formModule = {
						component: res.default,
						param: param,
					}
				})
				this.scanback()
			},
			closed() {
				this.param = null
				this.formModule = {
					component: null,
					param: null,
				}
			},
			submit(e) {
				this.popupShow = false
				this.$nextTick(() => {
					if (e.continue) {
						this.scan()
					}
				})
			}
		},
		components: {

		}
	}
</script>